import {Button} from '@material-ui/core'
import Modal from 'modules/reports/components/Modal'
import ModalActions from 'modules/reports/components/Modal/Actions'
import ModalBody from 'modules/reports/components/Modal/Body'
import ModalTitle from 'modules/reports/components/Modal/Title'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsUsersModal.styles'

type Props = {}

function ReportsUsersModal(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'modals', 'Users')

  function handleSubmit() {}

  return (
    <Modal data-testid={p()}>
      <ModalBody>
        <ModalTitle>ReportsUsers modal</ModalTitle>

        <div className={classes.content} data-testid={p('content')}>
          {pt('content')}
        </div>

        <ModalActions>
          <Button onClick={handleSubmit}>Submit</Button>
        </ModalActions>
      </ModalBody>
    </Modal>
  )
}

export default ReportsUsersModal
